import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { PoseGroup } from 'react-pose'
import { filter, compose } from 'ramda'
import { renderData, sortByInt } from '../../helpers'
import { useFetch } from '../../hooks'
import Icon from '../../components/Icon'
import Input from '../../components/inputs/FromInputFocus'
import ListItem from '../../components/ListItem';
import { ListWrap, ListTitle, ListTags, ListContainer } from '../../components/ListItem/styled'
import Container from '../../components/Container'
import FakeLoaderListItem from '../../components/FakeLoaderListItem'
import { Store } from '../../context/store'
import { SearchStyled, SearchButton, SearchWrapper, Items, SearchBox, SearchClose, SearchInputContainer, ItemsTitle, SearchContainer, StyledSearchHint, StyledSearchHintIcon, StyledSearchHintText } from './styled'

const SearchCow = React.memo(() => {
    const { actions } = Store();
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [filteredData, setFilteredData] = useState([]);
    const [isHint, setIsHint] = useState(false);

    const { response: responseCowSearch, error: errorCowSearch, fetching: fetchingCowSearch, doFetch: doFetchCowSearch } = useFetch({
        url: '/cow_search',
        method: 'GET',
        lazy: true
    })

    useEffect(() => {
        doFetchCowSearch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const toggleOpen = () => {
        setOpen(!open)
    }

    const handleToggleOpen = () => {
        if (!open) {
            doFetchCowSearch()
        }
        toggleOpen()
    }

    const filterList = list => {
        const text = searchText.trim();
        const sortList = sortByInt({ direct: 'asc', key: 'row_no' })
        const isContain = n => (n.row_no && n.row_no.toString().slice(0, text.length) === text) || (n.ear && n.ear.toString().slice(0, text.length) === text) || (n.tail && n.tail.toString().slice(0, text.length) === text)
        return compose(
            sortList,
            filter(
                isContain
            ))(list);
    }

    useEffect(() => {
        setFilteredData(filterList(responseCowSearch.data));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responseCowSearch, searchText]);

    useEffect(() => {
        if (searchText.length > 0 && filteredData.length > 5) {
            setIsHint(true);
        } else {
            setIsHint(false);
        }
    }, [filteredData, searchText]);

    useEffect(() => {
        actions.setCowsList(filteredData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredData])

    const renderDataState = renderData({ data: filteredData, error: errorCowSearch, fetching: fetchingCowSearch })

    const handleChangeSearch = e => setSearchText(e.target.value)

    const handleCloseSearch = () => {
        setOpen(false)
        setSearchText("")
    }

    const inputEl = useRef(null);

    return (
        <SearchStyled>
            <SearchButton onClick={handleToggleOpen}>
                <Icon name="loupe" />
            </SearchButton>
            <PoseGroup>
                {open &&
                    <SearchWrapper
                        key="search"
                    >
                        <SearchContainer>
                            <SearchInputContainer>
                                <Container>
                                    <SearchBox
                                        onSubmit={(e) => { e.preventDefault(); }}
                                    >
                                        <Input
                                            type="number"
                                            placeholder={t('search.placeholder1')}
                                            placeholderFocused={t('search.placeholder2')}
                                            name="search"
                                            onChange={handleChangeSearch}
                                            value={searchText}
                                            icon={searchText.length > 0 ? '' : 'loupe'}
                                            fullWidth
                                            reference={inputEl}
                                            marginVertical
                                            initialFocused={open}
                                        />
                                        <SearchClose
                                            onClick={handleCloseSearch}
                                        >
                                            {t('search.button_close')}
                                        </SearchClose>
                                    </SearchBox>
                                    {
                                        isHint &&
                                        <StyledSearchHint>
                                            <StyledSearchHintIcon name='tooltip' />
                                            <StyledSearchHintText>{t('search.hint')}</StyledSearchHintText>
                                        </StyledSearchHint>
                                    }
                                </Container>
                            </SearchInputContainer>
                            <Container>
                                <ItemsTitle>{t('search.title')}</ItemsTitle>
                            </Container>
                            {
                                renderDataState({
                                    fetching: () => <Items><FakeLoaderListItem /></Items>,
                                    error: error => <Container><div>{error.toString()}</div></Container>,
                                    data: data => (
                                        <Items> {
                                            data &&
                                            data.map(cow => (
                                                <ListItem
                                                    key={cow.row_id}
                                                    to={{
                                                        pathname: `/manage/herd/cow/${cow.row_no}`,
                                                        state: {
                                                            rowid: cow.row_id
                                                        }
                                                    }}
                                                >
                                                    <ListContainer>
                                                        <ListWrap>
                                                            <ListTitle>
                                                                {cow.row_no}
                                                            </ListTitle>
                                                        </ListWrap>
                                                        {
                                                            cow.info &&
                                                            cow.info.map(info => (
                                                                <ListWrap
                                                                    key={info}
                                                                >
                                                                    <ListTags bold>
                                                                        {info}
                                                                    </ListTags>
                                                                </ListWrap>
                                                            ))
                                                        }
                                                    </ListContainer>
                                                </ListItem>

                                            ))
                                        }
                                        </Items>
                                    )
                                })
                            }
                        </SearchContainer>
                    </SearchWrapper>
                }
            </PoseGroup>
        </SearchStyled>
    )
})

export default SearchCow
